import React from 'react';
import { MenuItem, Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useClassrooms from 'state/hooks/use-classrooms';
import Select from 'components/common/Select';

const t = (key: string, options?) => translate('classroom', key, options);

const ClassroomSelector: React.FC = () => {
  const [{ classrooms, activeClassroom, isLoading }, { setActiveClassroom }] = useClassrooms();
  const classes = useStyles();

  const setClassroom = (id) => {
    const foundClass = classrooms.find((classroom) => classroom.id === id);
    foundClass && setActiveClassroom(foundClass);
  };

  return (
    <Box className={classes.container}>
      {!isLoading && (
        <>
          {activeClassroom.name && (
            <Typography className={classes.text} variant="h2">
              {`${t('class')}:`}
            </Typography>
          )}
          {classrooms?.length <= 1 ? (
            // one or no classrooms. dont use select
            <Typography className={classes.text} variant="h2">
              {activeClassroom.name ?? t('noClassroom')}
            </Typography>
          ) : (
            // more than 1 classrooms. use the select
            <Select
              className={classes.select}
              value={activeClassroom.id ?? ''}
              renderValue={() => (
                <Typography variant="h2">{activeClassroom.name ?? t('selectClassroom')}</Typography>
              )}
              noBorder
              onChange={(e) => setClassroom(e.target.value)}
            >
              {classrooms.map((classroom) => (
                <MenuItem key={classroom.id} value={classroom.id as any}>
                  {classroom.name}
                </MenuItem>
              ))}
            </Select>
          )}
        </>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
  },
  text: {
    lineHeight: '3.28125rem',
    marginRight: '0.5rem',
  },
  select: {
    '& h2': {
      lineHeight: '2rem',
      paddingRight: '1rem',
    },
    '& svg': {
      color: theme.palette.link.main,
      fontSize: '2rem',
      top: 'auto',
    },
  },
}));

export default ClassroomSelector;
